export enum TRACK_FILE_STATES {
  NEW = 'new',
  OUTDATED = 'outdated',
  ONGOING = 'ongoing',
  FINISHED = 'finished',
  FAILED = 'failed'
}
